'use client'

import {Check} from 'lucide-react'
import type {SelectFilter} from '../types'
import * as UI from './filters.styled'

interface FilterButtonValuesProps {
  filter: SelectFilter
  onChange: (code: string, value: string) => void
}

export function FilterButtonValues({filter, onChange}: FilterButtonValuesProps) {
  return (
    <>
      {filter.values.map((filterValue) => (
        <UI.ButtonFilterValue
          key={`${filterValue.title}-${filterValue.value}`}
          onClick={() => onChange(filter.code, filterValue.value)}
          data-disabled={filterValue.disabled}
        >
          <span>{filterValue.title}</span>
          {filterValue.selected && <Check size={16} style={{marginBottom: 4}} />}
        </UI.ButtonFilterValue>
      ))}
    </>
  )
}
